/**
 * Client side image uploader with progress bar.
 * Supports multiple file uploads.
 * Must use input type="file" with multiple attribute.
 */
window.ImageUploaderV2 = new function () {
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    /**
     * Uploads all selected files and shows a unified progress bar.
     *
     * @param string form - The form selector.
     * @param string inputSelector - The file input selector.
     * @param string file_path - Server-side upload directory.
     */
    this.uploadImages = function (form, files, inputSelector, file_path) {
        const $form = jQuery(form);
        const $fileInput = $form.find(inputSelector);
        const totalImages = files.length;

        if (totalImages === 0) {
            alert('Please select at least one image.');
            return;
        }

        let uploadedCount = 0;
        let individualProgress = new Array(totalImages).fill(0);

        const $progressWrapper = $form.find('.progressWrapper');
        const $progressBar = $form.find('.uploadProgress');
        const $progressPercent = $form.find('.progressPercent');

        $progressWrapper.show();
        $progressBar.val(0);
        $progressPercent.text('0%');

        files.forEach((file, index) => {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('file_path', file_path);
            formData.append('_token', ImageUploaderV2.vars.token);

            jQuery.ajax({
                xhr: function () {
                    const xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function (evt) {
                        if (evt.lengthComputable) {
                            const percent = Math.round((evt.loaded / evt.total) * 100);
                            individualProgress[index] = percent;

                            const total = individualProgress.reduce((a, b) => a + b, 0);
                            const overallProgress = Math.round(total / totalImages);
                            $progressBar.val(overallProgress);
                            $progressPercent.text(overallProgress + '%');
                        }
                    }, false);
                    return xhr;
                },
                url: '/media/upload-image',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response && response.path) {
                        $form.append('<input type="hidden" name="uploaded_images[' + index + ']" value="' + response.path + '" />');
                    }

                    uploadedCount++;
                    const totalProgress = (uploadedCount / totalImages) * 100;
                    $progressBar.val(totalProgress);
                    $progressPercent.text(Math.round(totalProgress) + '%');

                    if (uploadedCount === totalImages) {
                        $fileInput.remove();
                        $form.off('submit');
                        $form.get(0).submit();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error("Image upload failed:", {
                        status: textStatus,
                        error: errorThrown,
                        response: jqXHR.responseText
                    });
                    $form.find('.error-notice').show();
                    $form.find('.progress-notice').hide();
                    uploadedCount++;
                }
            });
        });
    };
};
